import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const track = (event, params = {}) => {
  try { if (window.gtag) window.gtag("event", event, params); } catch (e) { console.warn("analytics event failed", event, e); }
};
